import { useMutation } from '@tanstack/react-query';

import { User } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ChangeUserPasswordFormSchemaValues } from 'src/features/users/utils/formSchema';

const RESOURCE = '/users/user/:userId/change-password/';

type MutationFnType = typeof mutationFn;

type DTO = {
    data: ChangeUserPasswordFormSchemaValues;
    userId: string;
};
const mutationFn = ({ data, userId }: DTO): Promise<User> => {
    return axios.post(formatResourcePath(RESOURCE, { userId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useChangeUserPassword };
